module.exports = __webpack_public_path__ + "af28395151b9d9e72fbf623333a6ca5e.png";